module.exports = __webpack_public_path__ + "static/swift3x-87d311093e178bf80e2690f788b60e80.png";